import React from 'react';

const Logo = () => {
  return (
    <div className="gzh-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="40"
        viewBox="0 0 80 40"
      >
        <path
          fill="#FFFFFF"
          fillRule="evenodd"
          d="M14.496 5.797c3.603 0 6.626.959 8.985 2.849a12.14 12.14 0 0 1 3.936 5.786l.123.39h-7.622c-.855-1.21-2.47-2.552-5.418-2.552a7.732 7.732 0 0 0-5.08 1.87c-1.617 1.433-2.471 3.567-2.471 6.168 0 2.534.794 4.638 2.292 6.094 1.367 1.324 3.29 2.052 5.418 2.052 1.866 0 3.417-.518 4.609-1.537a5.407 5.407 0 0 0 1.41-1.842l.088-.193h-5.118v-5.955h11.763v15.292h-6.412v-1.723c-1.667 1.455-4.138 2.287-6.876 2.287-3.84 0-7.38-1.404-9.966-3.95C1.475 28.192 0 24.442 0 20.307c0-4.136 1.53-7.876 4.3-10.533 2.676-2.564 6.295-3.978 10.196-3.978zm38.491.564v6.137l-12.864 15.11H53.14v6.595H30.809v-6.365l12.564-14.882H31.382V6.36h21.605zm10.146 0v10.587h9.951V6.36H80v27.842h-6.916V23.466h-9.951v10.737h-6.876V6.36h6.876z"
        />
      </svg>
    </div>
  );
};

export default Logo;
